// src/systems/numbersDeck.ts
//
// Phase 13 (WHEEL-09, WHEEL-10): canonical numbers deck + floor-guarded
// mutation API. The floor of 12 and the 0-locked rule belong to this
// module so Phase 15 consumables inherit the guards automatically.

import type { SlotNumber } from '../state/types';

export const NUMBERS_DECK_FLOOR = 12;

export function buildCanonicalNumbersDeck(): SlotNumber[] {
  const out: SlotNumber[] = [];
  for (let n = 0; n <= 36; n++) out.push(n as SlotNumber);
  return out;
}

export type RemoveNumberResult =
  | { ok: true; deck: SlotNumber[] }
  | { ok: false; reason: 'zero-locked' | 'floor' | 'not-found' };

/**
 * Remove a number from the deck. Pure — returns a new array, does not
 * mutate. Rejects:
 *   - `0` is non-removable (WHEEL-10)
 *   - removing would drop deck below NUMBERS_DECK_FLOOR (WHEEL-09)
 *   - the number is not present in the deck
 */
export function removeNumber(
  deck: readonly SlotNumber[],
  n: SlotNumber,
): RemoveNumberResult {
  if (n === 0) return { ok: false, reason: 'zero-locked' };
  if (deck.length <= NUMBERS_DECK_FLOOR) return { ok: false, reason: 'floor' };
  const idx = deck.indexOf(n);
  if (idx < 0) return { ok: false, reason: 'not-found' };
  const out = deck.slice();
  out.splice(idx, 1);
  return { ok: true, deck: out };
}
